<template>
    <div class="toast-page">
        <img :src="this.base64" alt="" class="pic_template">
        <div class="title"></div>
        <p class="text">少年你通过了此次天津博物馆鉴宝特训，特发此证！</p>
        <img :src="images.finishPic" class="pic">
        <p class="tag" v-if="$bridge.isWeixin">长按保存图片</p>
        <div class="share" @click="share"></div>
        <div class="weixin" v-if="weixin" @click="weixin=false"></div>
        <div class="temp" ref="imgTemplate" :style="{
            backgroundImage: `url(${images.templatePic}?v=${Math.random()})`
        }">
        </div>
    </div>
</template>

<script>
import wxShare from '@utils/wxShare';
import html2canvas from 'html2canvas';
import gameInfo from './assets/gameInfo';

export default {
    data() {
        return {
            name: 'tianjin',
            weixin: false,
            base64: ''
        };
    },
    computed: {
        images() {
            const info = gameInfo[this.name];
            return {
                finishPic: info.finishPic,
                templatePic: info.templatePic
            };
        }
    },
    methods: {
        share() {
            if (this.$bridge.isApp) {
                this.$bridge.share({
                    title: '鉴宝师培养计划 天津博物馆',
                    desc: '如果你天赋异禀，如果你兰质蕙心，如果你颖悟绝伦，皆可免试入门。',
                    link: `${location.origin}/guessdifferent`,
                    imgUrl: 'https://wwj.jijiagames.com/web/act/20181127/img/index_bg.png'
                });
            }
            else {
                this.weixin = true;
            }
        }
    },
    mounted() {
        html2canvas(this.$refs.imgTemplate, {
            scale: 1,
            logging: false,
            useCORS: true
        }).then(c => {
            this.base64 = c.toDataURL('image/png', 1);
        });
        wxShare({
            title: '鉴宝师培养计划 天津博物馆',
            desc: '如果你天赋异禀，如果你兰质蕙心，如果你颖悟绝伦，皆可免试入门。',
            link: `${location.origin}/guessdifferent`,
            imgUrl: 'https://wwj.jijiagames.com/web/act/20181127/img/index_bg.png'
        });
    }
};
</script>

<style lang="stylus" scoped>
.toast-page
    position fixed
    top 0
    left 0
    size 100%
    background url('./assets/img/game_bg.png') 0 0/100% 100% repeat
    padding 0 .54rem
    display flex
    flex-direction column
    justify-content center
    .pic_template
        position fixed
        size 100%
        top 0
        left 0
        z-index 10
        opacity 0
    .pic
        width 100%
        margin-bottom .71rem
    .title
        size 3.13rem .7rem
        background url('./assets/img/img_pass.png') 0 0/100% 100% no-repeat
        margin 0 auto
    .text
        width 4.28rem
        font-size .26rem
        line-height .5rem
        color #fff
        margin .1rem auto .8rem
        text-align center
    .share
        size 1.87rem .34rem
        margin .5rem auto 0
        background 0 0/100% 100% no-repeat
        background-image url('./assets/img/btn_share.png')
        position relative
        z-index 11
    .weixin
        size 100%
        position absolute
        top 0
        left 0
        background rgba(0,0,0,0.7) url('./assets/img/weixin.png') right 0/4.78rem 1.82rem no-repeat
        z-index 11
    .tag
        font-size .22rem
        color #e3e3e3
        text-align center
    .temp
        size 750px 1106px
        position absolute
        bottom -1106px
        background-color #000
        background-size 100% 100%
        background-repeat no-repeat
        background-position 0 0
</style>
